import { FunctionComponent } from 'react';

import LayoutContainer, { Sizes } from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageJobSectionJobBlocksJobLanguages: FunctionComponent<Props> = ({
    headline,
    list,
    single,
}) => {
    return (
        <StyledComponent
            className="public-page-job-section-job-blocks-job-skills"
        >
            <LayoutContainer size={Sizes.Small}>
                <div
                    className="headline"
                    dangerouslySetInnerHTML={{ __html: headline }}
                />
                <div className="list">
                    {list.map(element => (
                        <div
                            key={element?.id}
                            className="list-element"
                        >
                            <p
                                className="element-content"
                            >
                                {single} {element.name} - {element.languageLevelDisplay.label}
                            </p>
                        </div>
                    ))}
                </div>
            </LayoutContainer>

        </StyledComponent>
    );
};

export default PublicPageJobSectionJobBlocksJobLanguages;